export const checkPartner = (id?: null | string): boolean => {
  const { hostname } = window.location

  const isLocal = hostname === "localhost"

  const isStage = hostname === "cryptix-dashboard.justbanana.net"

  const isSandbox = hostname === "dashboard.sandbox.cryptix.io"

  const isProduction = hostname === "dashboard.cryptix.io"

  const sendCryptoLocal =
    id === "41931cbe-f7b2-4c03-a681-61ec160d7ff1" && isLocal

  const sendCryptoStage =
    id === "41931cbe-f7b2-4c03-a681-61ec160d7ff1" && isStage

  const sendCryptoSandbox =
    id === "aad23ddd-ac54-4237-a6e9-23f2772cb658" && isSandbox

  const sendCryptoProduction =
    id === "c03e1dfc-67c9-4bfb-b421-f095cef5380d" && isProduction

  return [
    sendCryptoLocal,
    sendCryptoStage,
    sendCryptoSandbox,
    sendCryptoProduction,
  ].some(Boolean)
}
